<template>
  <div
    v-if="report"
    class="card border-0 rounded-4 shadow-sm bg-white p-4 w-100 mt-3"
  >
    <!-- Title -->
    <div class="text-center mb-4">
      <h5 class="fw-bold text-uppercase mb-0">
        Verification Report
      </h5>
    </div>

    <!-- Report Meta -->
    <table class="table table-bordered text-xxs mb-4">
      <tbody>
        <tr>
          <td class="fw-bold">Report Generated:</td>
          <td>{{ report.generated_at }}</td>
        </tr>
        <tr>
          <td class="fw-bold">Report Type:</td>
          <td>{{ report.report_type }}</td>
        </tr>
        <tr>
          <td class="fw-bold">Reference Number:</td>
          <td>{{ report.reference_number }}</td>
        </tr>
      </tbody>
    </table>

    <!-- 1. Consumer Information -->
    <h6 class="fw-bold text-uppercase mb-2">1. Consumer Information</h6>
    <table class="table table-bordered text-xxs mb-4">
      <tbody>
        <tr><td class="fw-bold">Full Name:</td><td>{{ report.consumer.full_name }}</td></tr>
        <tr><td class="fw-bold">ID Number:</td><td>{{ report.consumer.id_number }}</td></tr>
        <tr><td class="fw-bold">Date of Birth:</td><td>{{ report.consumer.date_of_birth }}</td></tr>
        <tr><td class="fw-bold">Age:</td><td>{{ report.consumer.age }}</td></tr>
        <tr><td class="fw-bold">Gender:</td><td>{{ report.consumer.gender }}</td></tr>
        <tr><td class="fw-bold">Title:</td><td>{{ report.consumer.title }}</td></tr>
        <tr><td class="fw-bold">Marital Status:</td><td>{{ report.consumer.marital_status }}</td></tr>
        <tr><td class="fw-bold">Privacy Status:</td><td>{{ report.consumer.privacy_status }}</td></tr>
      </tbody>
    </table>

    <!-- 2. Contact Information -->
    <h6 class="fw-bold text-uppercase mb-2">2. Contact Information</h6>
    <table class="table table-bordered text-xxs mb-4">
      <tbody>
        <tr><td class="fw-bold">Mobile Number:</td><td>{{ report.contact.mobile }}</td></tr>
        <tr><td class="fw-bold">Home Telephone:</td><td>{{ report.contact.home }}</td></tr>
        <tr><td class="fw-bold">Work Telephone:</td><td>{{ report.contact.work }}</td></tr>
        <tr><td class="fw-bold">Email Address:</td><td>{{ report.contact.email }}</td></tr>
        <tr><td class="fw-bold">Residential Address:</td><td>{{ report.contact.residential_address }}</td></tr>
        <tr><td class="fw-bold">Postal Address:</td><td>{{ report.contact.postal_address }}</td></tr>
      </tbody>
    </table>

    <!-- 3. Employment History -->
    <h6 class="fw-bold text-uppercase mb-2">3. Employment History</h6>
    <table class="table table-bordered text-xxs mb-4">
      <thead class="table-light">
        <tr>
          <th>Employer</th>
          <th>Designation</th>
          <th>First Reported</th>
          <th>Last Updated</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(job, idx) in report.employment_history" :key="idx">
          <td>{{ job.employer }}</td>
          <td>{{ job.designation }}</td>
          <td>{{ job.first_reported }}</td>
          <td>{{ job.last_updated }}</td>
        </tr>
      </tbody>
    </table>

    <!-- 4. Fraud & Verification Status -->
    <h6 class="fw-bold text-uppercase mb-2">4. Fraud & Verification Status</h6>
    <table class="table table-bordered text-xxs">
      <tbody>
        <tr><td class="fw-bold">Home Affairs Verification:</td><td>{{ report.fraud.home_affairs }}</td></tr>
        <tr><td class="fw-bold">Deceased Status:</td><td>{{ report.fraud.deceased_status }}</td></tr>
        <tr><td class="fw-bold">Deceased Date:</td><td>{{ report.fraud.deceased_date }}</td></tr>
        <tr><td class="fw-bold">SAFPS Listing:</td><td>{{ report.fraud.safps }}</td></tr>
        <tr><td class="fw-bold">Protective Verification:</td><td>{{ report.fraud.protective_verification }}</td></tr>
        <tr><td class="fw-bold">Employer Fraud Verification:</td><td>{{ report.fraud.employer_fraud }}</td></tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "VerificationReport",

  props: {
    report: {
      type: Object,
      required: true,
      default: () => ({
        generated_at: "10 December 2025 at 15:06:21",
        report_type: "Consumer Credit Report",
        reference_number: "C1109960605-857948",
        
        consumer: {
          full_name: "KHATHUTSHELO GLADYS LADZANI",
          id_number: "7609150941087",
          date_of_birth: "1976-09-15",
          age: "49 years",
          gender: "Female",
          title: "Miss",
          marital_status: "Single",
          privacy_status: "ACCEPTS CONTACTS"
        },
        
        contact: {
          mobile: "0794575939",
          home: "",
          work: "",
          email: "",
          residential_address: "HOUSE NO 1030 MILUWANI THOHOYANDOU 0950",
          postal_address: "HOUSE NO 1030 MILUWANI THOHOYANDOU 0950"
        },
        
        employment_history: [
          {
            employer: "SINUVWANI",
            designation: "Not Specified",
            first_reported: "2005-05-26",
            last_updated: "2015-03-15"
          },
          {
            employer: "NSA SECURITY SERVICES",
            designation: "Not Specified",
            first_reported: "2005-05-26",
            last_updated: "2009-03-28"
          }
        ],
        
        fraud: {
          home_affairs: "Yes",
          deceased_status: "No",
          deceased_date: "",
          safps: "Access disabled to view this information",
          protective_verification: "Access disabled to view this information",
          employer_fraud: "Access disabled to view this information"
        }
      })
    }
  }
};
</script>